export const API_ACTION_TYPES = {
    POST: 'POST',
    DELETE: 'DELETE',
    PATCH: 'PATCH',
    PUT: 'PUT',
    GET: 'GET'
};

export const AJAX_DEBOUNCE_ACTION_TYPES = {
    START: 'START',
    FAIL: 'FAIL',
    SUCCESS: 'SUCCESS',
    END: 'END'
};
export const AJAX_END_TIMEOUT = 700;
export const SERVICE_PROVIDER = {
    LINE: 'LINE',
    TAPPIE: 'TAPPIE',
    SEVER: 'SEVER'
};

export const STORE_KEYS = {
    SERVER_CUSTOMER: 'server_customer',
    SERVER_PRODUCT: 'server_product'
};
